// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCDMxd4TULTYLAPQo4_1ARzb1vyTrzj3pY",
  authDomain: "teqlucviewpoint.firebaseapp.com",
  projectId: "teqlucviewpoint",
  storageBucket: "teqlucviewpoint.firebasestorage.app",
  messagingSenderId: "367090140381",
  appId: "1:367090140381:web:70283e511716a305b90734"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { database, auth, db };
